import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ArrowRightLeft, Loader2, RotateCcw, Save } from "lucide-react";
import { errText, fetchNmCfg, fetchTransfers, resetNmDemo, ron, saveNmCfg } from "@/lib/bf";
import { DemoTag } from "./BFStockTotal";

export default function BFTransfers() {
  const [rows, setRows] = useState(null);
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState("");
  const [open, setOpen] = useState("");
  useEffect(() => { fetchTransfers().then(setRows).catch(() => setRows([])); fetchNmCfg().then((c) => setCfg((x) => x || c)).catch(() => {}); }, []);
  const save = () => { setBusy("save"); saveNmCfg({ ...cfg, markup: Number(String(cfg.markup).replace(",", ".")) || 0 }).then(() => toast.success("Adaos salvat")).catch((e) => toast.error(errText(e, "Nu am putut salva"))).finally(() => setBusy("")); };
  const reset = () => {
    if (!window.confirm("Ștergem toate datele de probă (stoc, facturi, chitanțe, transferuri, coada de facturare) și le generăm din nou?")) return;
    setBusy("reset");
    resetNmDemo().then(() => { toast.success("Date de probă regenerate"); return fetchTransfers().then(setRows); }).catch((e) => toast.error(errText(e, "Nu am putut reseta"))).finally(() => setBusy(""));
  };
  return (
    <section className="invite-box" data-testid="bf-transfers">
      <h3><ArrowRightLeft size={18} /> Transferuri între firme <DemoTag /></h3>
      <p className="st-hint">Când firma pe care facturați nu are destul stoc, produsul se ia din lotul cel mai vechi din altă firmă: ieșire acolo, intrare în firma care facturează, la prețul de achiziție plus adaosul de mai jos.</p>
      {cfg && (
        <div className="share-actions">
          <label className="bf-inv-field"><span>Adaos între firme (%)</span><input value={cfg.markup} onChange={(e) => setCfg({ ...cfg, markup: e.target.value })} data-testid="bf-tr-markup" /></label>
          <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy === "save"} data-testid="bf-tr-markup-save">{busy === "save" ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Salvează adaosul</button>
          <button type="button" className="st-btn st-btn--ghost" onClick={reset} disabled={busy === "reset"} data-testid="bf-nm-reset">{busy === "reset" ? <Loader2 size={14} className="animate-spin" /> : <RotateCcw size={14} />} Resetează datele de probă</button>
        </div>
      )}
      {rows && !rows.length && <p className="st-hint" data-testid="bf-tr-empty">Niciun transfer încă. Apar automat când trimiteți o comandă la facturare pe o firmă fără stoc suficient.</p>}
      <ul className="bfa-leads">
        {(rows || []).map((t) => (
          <li key={t.id} data-testid={`bf-tr-${t.no}`} onClick={() => setOpen(open === t.id ? "" : t.id)} className="bf-tr-row">
            <div>
              <b>{t.no} · {t.from_name} → {t.to_name}</b>
              <span>{t.date.split("-").reverse().join(".")} · comanda {t.proforma_no} · {t.lines.length} produse · adaos {t.markup}% · NeoManager {t.neo_no}</span>
              {open === t.id && t.lines.map((l) => <span key={l.code + l.entry} className="bf-tr-line">{l.q} × {l.name} · lot din {l.entry.split("-").reverse().join(".")} · {ron(l.cost)} → {ron(l.price)}</span>)}
            </div>
            <span className="bfa-pf-total">{ron(t.total)}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
